import { IAddress } from '../address/models';
import { IDepartment } from '../department/models';
import { ISimplifiedVisualMaterial } from '../material/models';
import { OrderStatus } from '../orders/models';
import { PaginatedListResponseDeprecatedType, CommonGetListType, ICommonResponse } from '../types';
import { IBranch, IContactPerson } from '../users/models';

export enum CaseCategory {
  Case = 'CASE',
  Location = 'LOCATION',
  Portrait = 'PORTRAIT',
  Group = 'GROUP',
  IntroOutro = 'INTRO_OUTRO',
  Shop = 'SHOP',
  Matterport = 'MATTERPORT',
  BeforeAfter = 'BEFORE_AFTER',
}

export enum CaseMaterialStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVING = 'ARCHIVING',
  RESTORING = 'RESTORING',
  ARCHIVED = 'ARCHIVED',
}

export enum LinkType {
  InteractiveFloorPlanEditor = 'interactiveFloorPlanEditor',
  HotSpotEditor = 'hotspotEditor',
  HotSpotZip = 'hotspotZip',
}

export interface IDatahubCase {
  id: string;
  reference: string;
  updatedAt?: Date;
  deliveryDate: Date | null;
  modifiedDate?: Date;
  departmentId: IBranch['id'];
  departmentName: IBranch['name'];
  address: string;
  addressObj?: Omit<IAddress, 'id'>;
  orderStatus: OrderStatus;
  categories?: CaseCategory[];
  hasMaterials: boolean;
  isArchived: boolean;
  clientId?: string;
  materialStatus: CaseMaterialStatus;
  contactPersons: IContactPerson[];
  property?: ICasePropertyDetails;
}

export interface IGetCasesListParams extends CommonGetListType<'ModifiedDate' | 'Reference' | 'Address' | 'Score'> {
  departmentId?: IDepartment['id'][];
  status?: OrderStatus[];
  category?: CaseCategory[];
  fromDate?: Date;
  toDate?: Date;
  includeNoOrders?: boolean;
  signal?: AbortSignal;
}

export interface IGetDatahubCasesListParams extends CommonGetListType<'id'> {
  axCustomerIds?: IBranch['id'][];
  searchString?: string;
  deliveredProductCategories?: string[];
  modifiedDateFrom?: string;
  modifiedDateTo?: string;
  latestOrderRelatedChangeFrom?: string;
  latestOrderRelatedChangeTo?: string;
  mustHaveOrder?: boolean;
  sortOrder?: 'ModifiedDate' | 'Reference' | 'Address' | 'Score';
  sortDirection?: 'Asc' | 'Desc';
}

export interface IGetCasesListResponse extends PaginatedListResponseDeprecatedType<IDatahubCase> {}

export interface ICaseFilters {
  categories: CaseCategory[];
  statuses: OrderStatus[];
  departments: IDepartment[];
}

export interface ICaseOrder {
  id: string;
  date: Date;
  salesId: number;
}

export interface IUpdateCaseAddressParams {
  caseId: IDatahubCase['id'];
  street: string;
  buildingNumber: string;
  buildingFloor?: string;
  buildingDoor?: string;
  cityArea?: string;
  zip: string;
  city: string;
  country?: string;
}

export interface ICaseWithVisualMaterials extends Pick<IDatahubCase, 'id' | 'address'> {
  visualMaterials: ISimplifiedVisualMaterial[];
}

export interface ICasePropertyDetails {
  type?: string;
  livingArea?: number;
  basementArea?: number;
  floors?: number;
}

export interface ICaseDetails {
  address?: IAddress;
  property?: ICasePropertyDetails;
  contactPersons: IContactPerson[];
}

export interface ICaseDetailsRequestParams {
  case:
    | IDatahubCase
    | {
        reference: IDatahubCase['reference'];
        id?: IDatahubCase['id'];
      };
  address: IAddress | Record<string, never>;
  contactPersons?: IContactPerson[];
  property?: ICasePropertyDetails;
  branchId: IBranch['id'];
}

export interface ITextUpdateResponse extends ICommonResponse {
  failedFields: Array<{
    name: string;
  }>;
}
